export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getVerdictColor(verdict) {
  const v = (verdict || "").toUpperCase();
  if (v === "GRAB") return { bg: "#00E676", text: "#0A0A0A", border: "#0A0A0A" };
  if (v === "CAUTION") return { bg: "#FFEA00", text: "#0A0A0A", border: "#0A0A0A" };
  return { bg: "#FF1744", text: "#FFFFFF", border: "#0A0A0A" };
}

export function formatPrice(val) {
  if (!val && val !== 0) return "$0";
  return `$${Number(val).toFixed(0)}`;
}

export function formatPriceRange(low, high) {
  if (!low && !high) return "$0";
  if (low === high) return formatPrice(low);
  return `${formatPrice(low)}-${formatPrice(high)}`;
}
